<template>
  <div class="hello">

    <div v-if="success">
      <h1 class="is-size-1 has-text-centered">{{ $t('This form has been sent successfully.') }} <i>¡Gracias! </i>
      </h1>
    </div>

    <form v-else @submit.prevent="submit" novalidate>
        <div class="field">
            <label class="label">{{ $t('Name of cocktail')}} <span class="required">*</span></label>
            <div class="control">
                <input v-model="nameOfCocktail" type="text" class="input">
            </div>
            <div class="has-text-error-message" v-if="v$.nameOfCocktail.$error">{{ $t('nec') }}</div>
        </div>

        <div class="field">
            <label class="label">{{$t('Short description: please provide a short description of the cocktail.')}} <span class="required">*</span></label>
            <div class="control">
                <textarea v-model="shortDesc" class="textarea"></textarea>
            </div>
            <div class="has-text-error-message" v-if="v$.shortDesc.$error">{{ $t('nec') }}</div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Quick tip / quote')}}</label>
            <div class="control">
                <textarea v-model="quickTip" class="textarea"></textarea>
            </div>
        </div>
        
        <div class="field">
            <label class="label">{{ $t('Created by')}}</label>
            <div class="control">
                <input v-model="createdBy" type="text" class="input">
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Company')}}</label>
            <div class="control">
                <input v-model="company" type="text" class="input">
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('City')}}</label>
            <div class="control">
                <input v-model="city" type="text" class="input">
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Country')}}</label>
            <div class="select is-fullwidth">
                <select v-model="country">
                    <option v-for="country in countries" :value="country.value" :key="country.label">
                    {{ country.label }}
                    </option>
                </select>
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Website')}}</label>
            <div class="control">
            <input v-model="website" type="url" class="input" placeholder="https://">
            <div class="has-text-error-message" v-if="v$.website.$error">{{ $t('url') }}</div>
            </div>
        </div>

        <label class="label">{{ $t('Style of sherry in cocktail')}} <span class="required">*</span></label>
        <div v-for="(type,i) in sherryStyles" :key="i" class="field">
          <input class="is-checkradio" :id="`exampleRtlRadio1_${i}`" type="radio" :name="`exampleRtlRadio1_${i}`" :value="type.value" v-model="sherryStyle">
          <label :for="`exampleRtlRadio1_${i}`">{{type.value}}</label>
        </div>
        <div class="has-text-error-message" v-if="v$.sherryStyle.$error">{{ $t('nec') }}</div>


        <label class="label">{{ $t('Ingredients')}}</label>
        
        <div v-for="(ingredient,i) in ingredients" :key="i" class="columns">
                        
            <div class="column is-6">
                <div class="field">
                    <div class="control">
                        <input v-model="ingredient.qty" type="number" class="input">
                    </div>
                </div>
            </div>
            
            <div class="column is-6">
                <div class="field">
                    <div class="control">
                        <input v-model="ingredient.of" type="text" class="input">
                    </div>
                </div>
            </div>

            <div class="column is-2">
                <button style="background: #D37700 !important; font-size: 14px; padding: 20px 0px;border: none" v-if="i>0"
                        class="button is-uppercase has-text-weight-bold is-fullwidth has-text-white" @click="removeIngred(i)"
                        type="button">X
                </button>
            </div>
        </div>

        <div class="pb-5">
          <button style="background: #D37700 !important; font-size: 14px; padding: 20px 40px;border: none"
                  v-if="ingredients.length<5"
                  class="button is-info is-uppercase has-text-weight-bold" @click="addIngred" type="button">Add Ingredient
          </button>
        </div>

        <div class="field">
            <label class="label">{{ $t('Instructions')}} <span class="required">*</span></label>
            <div class="control">
                <textarea v-model="instructions" class="textarea"></textarea>
            </div>
            <div class="has-text-error-message" v-if="v$.instructions.$error">{{ $t('nec') }}</div>
        </div>


        <label class="label">{{ $t('Please upload a picture of you or your venues logo')}} </label>
        <div class="uploader uploader1">
            <file-upload v-show="files.length == 0"
                        input-id="file1"
                        class="has-text-centered "
                        extensions="jpg,jpeg,png"
                        accept="image/png,image/jpeg"
                        post-action="/api/upload-image/"
                        ref="file1"
                        v-model="files"
                        :headers="{'X-CSRFTOKEN': csrf}"
                        :drop="'.uploader1'"
                        :size="1024 * 1024 *4"
                        @input-filter="inputFilter"
                        @input-file="inputFile"
            >
            <div>
                <div class="is-size-6 has-text-weight-bold">{{ $t('Files must be less than 2 MB.')}}
                <br>
                {{ $t('Allowed file types: gif jpg jpeg')}}.
                </div>
            </div>

            </file-upload>
            <div v-if="files.length > 0">
            <div class="columns is-gapless">
                <div class="column is-4">
                <img
                    :src="files.length ? files[0].thumb : 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm'"
                    class="upload-photo"/>
                </div>
                <div class="column">
                <div>
                    <p class="pb-5">{{ files[0].name }}</p>

                    <button
                        style="background: #D37700 !important; font-size: 14px; padding: 10px 10px;border: none;margin-top:8px"
                        class="button is-uppercase has-text-weight-bold has-text-white" @click="files=[]"
                        type="button">X
                    </button>
                </div>
                </div>
            </div>
            </div>
        </div>


        <label class="label">{{ $t('Please upload a picture of your cocktail')}} <span class="required">*</span></label>
        <div class="uploader uploader2">
            <file-upload v-show="files2.length == 0"
                        input-id="file2"
                        class="has-text-centered "
                        extensions="jpg,jpeg,png"
                        accept="image/png,image/jpeg"
                        post-action="/api/upload-image/"
                        ref="file2"
                        v-model="files2"
                        :headers="{'X-CSRFTOKEN': csrf}"
                        :drop="'.uploader2'"
                        :size="1024 * 1024 *4"
                        @input-filter="inputFilter"
                        @input-file="inputFile2"
            >
            <div>
                <div class="is-size-6 has-text-weight-bold">{{ $t('Files must be less than 2 MB.')}}
                <br>
                {{ $t('Allowed file types: gif jpg jpeg.')}}
                </div>
            </div>

            </file-upload>
            <div v-if="files2.length > 0">
            <div class="columns is-gapless">
                <div class="column is-4">
                <img
                    :src="files2.length ? files2[0].thumb : 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm'"
                    class="upload-photo"/>
                </div>
                <div class="column">
                <div>
                    <p class="pb-5">{{ files2[0].name }}</p>

                    <button
                        style="background: #D37700 !important; font-size: 14px; padding: 10px 10px;border: none;margin-top:8px"
                        class="button is-uppercase has-text-weight-bold has-text-white" @click="files2=[]"
                        type="button">X
                    </button>
                </div>
                </div>
            </div>
            </div>
            <div class="has-text-error-message" v-if="v$.f2.$error">{{ $t('nec') }}</div>
        </div>

        <label  class="label">{{ $t('Please subscribe me to your newsletter')}}</label>
        <div class="field">
            <input v-model="newsletter" class="is-checkradio" id="newsletterCheckbox" type="checkbox"
                name="newsletterCheckbox"
                checked="checked">
            <label for="newsletterCheckbox">{{ $t('I accept to recieve promotions, offers and commercial communications')}}</label>
        </div>

        <div class="field">
            <label class="label">{{ $t('Contact email address (not for publication)')}}</label>
            <div class="control">
                <input v-model="contactEmail" type="email" class="input">
                <div class="has-text-error-message" v-if="v$.contactEmail.$error">{{ $t('email') }}</div>
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Url for Facebook (not for publication)')}}</label>
            <div class="control">
                <input v-model="facebook" type="url" class="input" placeholder="https://">
                <div class="has-text-error-message" v-if="v$.facebook.$error">{{ $t('url') }}</div>
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Handle for Twitter (not for publication)')}}</label>
            <div class="control">
                <input v-model="twitter" type="url" class="input" placeholder="https://">
                <div class="has-text-error-message" v-if="v$.twitter.$error">{{ $t('url') }}</div>
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Handle for instagram (not for publication)')}}</label>
            <div class="control">
                <input v-model="instagram" type="url" class="input" placeholder="https://">
                <div class="has-text-error-message" v-if="v$.instagram.$error">{{ $t('url') }}</div>
            </div>
        </div>

        <div class="field">
            <input v-model="termsAndConditions" class="is-checkradio" id="termsAndConditionsCheckbox" type="checkbox" name="termsAndConditionsCheckbox"
                checked="checked">
            <label for="termsAndConditionsCheckbox">{{ $t('I accept the conditions laid out in the')}}  <a style="color: #D37700; text-decoration: underline"
                                                        href="https://www.sherry.wine/es/legal">{{ $t('Legal Notice')}}</a>
                                                        {{ $t('AND')}} 
                                                         <a style="color: #D37700; text-decoration: underline"
                                                        href="https://www.sherry.wine/es/legal">{{ $t('Privacy Policy')}}</a>
            <span class="required"> *</span></label>
            <div class="has-text-error-message" v-if="v$.termsAndConditions.$error">{{ $t('nec')}}{{ $t('nec') }}</div>
        </div>

        <div class="pt-5">
            <button style="background: #D37700; font-size: 14px; padding: 20px 40px;border: none"
                    type="submit" class="button is-uppercase has-text-white has-text-weight-bold ">{{ $t('Send')}}
            </button>
        </div>

    </form>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core';
import {required, email, integer, url, helpers, requiredIf} from '@vuelidate/validators';
import VueUploadComponent from 'vue-upload-component';
import axios from "axios";

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

const phone = helpers.regex(/^\+34[0-9 ]{5,10}$/);
//const urlx = helpers.regex(/^http.*$/);

const time = helpers.regex(/^(0?[1-9]|1[012]):[0-5][0-9]$/);

import FileComponent from "./FileComponent.vue";

const hasddress = (value, siblings) => {
  console.log("siblings");
  console.log(siblings);
  return true && value;
};

const countries = require('i18n-iso-countries');
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

export default {

  setup() {
    return {v$: useVuelidate()};
  },
  name: 'Cocktails',
  components: {
    'file-upload': VueUploadComponent,
    'file-component': FileComponent,
  },
  props: {
    csrf: String,
    lang: String,
    waglocale: String,
    winestyles: Object
  },
  data() {
      return {
        success: false,

        files: [],
        files2: [],

        f1: null,
        f2: null,

        nameOfCocktail: '',
        shortDesc: '',
        quickTip: '',
        createdBy: '',
        company: '',
        city: '',
        country: '',
        
        website: '',
        sherryStyle: 'Manzanilla',
        sherryStyles: [],
        ingredients: [
            {
                qty: 0,
                of: ''
            }
        ],

        instructions: '',   
        newsletter: false,
        contactEmail: '',
        instagram: '',
        facebook: '',
        twitter: '',
        termsAndConditions: null,
      }
  },
  validations() {
    function termsAgreed() {
      return this.termsAndConditions
    }
    return {
        f2: {required},
        nameOfCocktail: {required},
        shortDesc: {required},
        website: {url},
        sherryStyle: {required},
        instructions: {required},
        contactEmail: {email},
        facebook: {url},
        instagram: {url},
        twitter: {url},
        termsAndConditions: {required, termsAgreed}
    };
  },
  methods: {
    doSuccess() {
      this.success = true;
      //this.scrollToClass('event')
      window.scrollTo(0, 0);
    },

    async submit() {
        const result = await this.v$.$validate();
        if (!result) {
            // notify user form is invalid
            this.scrollToClass('has-text-error-message');
            return;
        }

        const formData = {
            f1: this.f1,
            f2: this.f2,
            nameOfCocktail: this.nameOfCocktail,
            shortDesc: this.shortDesc,
            quickTip: this.quickTip,
            createdBy: this.createdBy,
            company: this.company,
            city: this.city,
            country: this.country,
            website: this.website,
            sherryStyle: this.sherryStyle,
            ingredients: this.ingredients,

            instructions: this.instructions,
            newsletter: this.newsletter,
            contactEmail: this.contactEmail,
            instagram: this.instagram,
            facebook: this.facebook,
            twitter: this.twitter,
            termsAndConditions: this.termsAndConditions,
            waglocale: this.waglocale
        };

        axios.post("/api/cocktail/", formData)
            .then((res) => {
                console.log(res);
                this.doSuccess();
                // this.success = true;
            })
            .catch((err) => {
                alert("Ha habido un error, contacta con soporte");
            });
    },

    scrollToClass(className) {
      const el = this.$el.getElementsByClassName('has-text-error-message')[0];
      if (el) {
        el.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
      }
    },

    addIngred() {
      this.ingredients.push({
                qty: 0,
                of: '',
            });
    },
    removeIngred(i) {
      this.ingredients.splice(i, 1);
    },
    async inputFile(newFile, oldFile) {
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
            if (!this.$refs.file1.active) {
            this.$refs.file1.active = true;
            //this.progress(newFile, oldFile)
            }
        }
    },
    
    async inputFile2(newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.file2.active) {
          this.$refs.file2.active = true;
          //this.progress(newFile, oldFile)
        }
      }
    },

    inputFilter(newFile, oldFile, prevent) {

      if (newFile && !oldFile) {

        if (!newFile.name.match((/.png|.jpg|.gif$/))) {
          alert("El archivo tiene que ser png o jpg");
          return prevent();
        }
      }

      if (newFile.size > 1024 * 1024 * 4) {
        alert("El archivo tiene que tener menos de 4 MB");
        return prevent();
      }

      if (newFile && newFile.error === "" && newFile.file && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = '';
        let URL = (window.URL || window.webkitURL);
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        newFile.thumb = '';
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob;
        }
      }
    },

  },
  computed: {
    countries () {
      const list = countries.getNames('en', { select: 'official' })
      return Object.keys(list).map((key) => ({ value: key, label: list[key] }))
    }
  },
  watch: {
      files: {
        handler: function (files, oldVal) {
          if(files.length > 0 && files[0].response && files[0].response.id){
            this.f1 = files[0].response.id
            return
          }
          this.f1 = null

        },
        deep: true
      },
      files2: {
        handler: function (files2, oldVal) {
          if(files2.length > 0 && files2[0].response && files2[0].response.id){
            this.f2 = files2[0].response.id
            return
          }
          this.f2 = null
        },
        deep: true
      }
},
  mounted() {
    this.$i18n.locale = this.lang;

    Object.entries(JSON.parse(this.winestyles)).forEach(item => {
      this.sherryStyles.push({
        'id': item[0],
        'value': item[1]
      });
    })
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.is-checkradio[type=checkbox] + label::after, .is-checkradio[type=checkbox] + label:after {
  color: #292624;
  border-color: #292624;

}

.is-checkradio[type=checkbox] + label::before, .is-checkradio[type=checkbox] + label:before {
  background: #FBF5EF;

}


label.label {
  margin-top: 30px;
}

dio[type=checkbox] + label::before, .is-checkradio[type=checkbox] + label:before, .is-checkradio[type=radio] + label::before, .is-checkradio[type=radio] + label:before {
  border-color: #FBF5EF;
}

.is-checkradio[type=checkbox]:hover:not([disabled]) + label::before, .is-checkradio[type=checkbox]:hover:not([disabled]) + label:before, .is-checkradio[type=radio]:hover:not([disabled]) + label::before, .is-checkradio[type=radio]:hover:not([disabled]) + label:before {
  border-color: #d37700 !important;

}

.uploader {
  padding: 30px;
  background: #FBF5EF;
  border: 1px dashed #C3B193;
  border-radius: 10px;
  width: 100%;
  display: block;

}

.has-text-error-message {
  background: darkred;
  color: white !important;
  padding: 5px 10px;
  border-radius: 5px;
  font-weight: 600;
  margin-top: 3px;
  display: block;
}

.upload-photo {
  width: 90%;
  height: auto;
  display: block;

}
</style>